class HomeBrowseDisclosure extends HTMLElement {
  connectedCallback() {
    this.summary = this.querySelector('.home-browse__summary');

    if (!this.summary) {
      return;
    }

    this.onToggle = this.toggle.bind(this);
    this.summary.addEventListener('click', this.onToggle);
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.onToggle);
  }

  toggle() {
    const open = this.classList.toggle('is-open');
    this.summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
}

if (!customElements.get('home-browse-disclosure')) {
  customElements.define('home-browse-disclosure', HomeBrowseDisclosure);
}

export default HomeBrowseDisclosure;
